export const CURRENT_ACCOUNT_MASK = '0-0||00-0||000-0||0000-0||00000-0';
